
/**
 * @name DOMinsertAfter
 * @description This function is adding HTMLElement after any other HTMLElement
 * @param {HTMLElement} $el The element you are going to add
 * @param {NodeSelector} $referenceNode
 * @example how to use it
 *
let newEl = document.createElement('div');
newEl.innerHTML = '<p>Hello World!</p>';
var ref = document.querySelector('div.before');
insertAfter(newEl, ref);
 *
 * @export {function}
 */
export default function insertAfter ($el, $referenceNode) {
    $referenceNode.parentNode.insertBefore($el, $referenceNode.nextSibling);
};